import React, { useState, useEffect } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const AdminRegisterHost = () => {
  const [formData, setFormData] = useState({
    Email: "",
    Password: "",
    Hostname: "",
    Contact: "",
    platformId: "",
    IsApproved : 1
  });
  const [platforms, setPlatforms] = useState([]);
  const [validated, setValidated] = useState(false);
  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const res = await axios.get(`${API}/api/host/platforms`);
        setPlatforms(res.data);
      } catch (err) {
        console.error("Error fetching platforms:", err);
      }
    };
    fetchPlatforms();
  }, [API]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setValidated(true);
    if (form.checkValidity() === false) {
      // shows layout with validation errors
      return;
    }
    //perform custom validation if needed, then send
    axios.post(`${API}/api/host/register`, formData)
      .then(res => {alert(res.data)})
      .catch(err => {console.error("Register failed:", err)
        alert(err.response.data.message)
      });
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Form.Group controlId="Email">
        <Form.Label>Email *</Form.Label>
        <Form.Control
          required
          type="email"
          name="Email"
          value={formData.Email}
          onChange={handleChange}
          placeholder="Enter email"
        />
        <Form.Control.Feedback type="invalid">
          Please provide a valid email.
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="Password">
        <Form.Label>Password *</Form.Label>
        <Form.Control
          required
          type="password"
          name="Password"
          value={formData.Password}
          onChange={handleChange}
          placeholder="Enter password"
          minLength={8}
        />
        <Form.Control.Feedback type="invalid">
          Password must be at least 8 characters.
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId="Hostname">
        <Form.Label>Hostname</Form.Label>
        <Form.Control
          type="text"
          name="Hostname"
          value={formData.Hostname}
          onChange={handleChange}
          placeholder="Hostname"
        />
      </Form.Group>

      <Form.Group controlId="Contact">
        <Form.Label>Contact</Form.Label>
        <Form.Control
          type="tel"
          name="Contact"
          value={formData.Contact}
          onChange={handleChange}
          placeholder="Contact number"
        />
      </Form.Group>

      <Form.Group controlId="platformId">
        <Form.Label>Platform *</Form.Label>
        <Form.Control
          as="select"
          required
          name="platformId"
          value={formData.platformId}
          onChange={handleChange}
        >
          <option value="">Select platform…</option>
          {platforms.map(p => (
            <option key={p.PlatformID} value={p.PlatformID}>
              {p.PlatformName}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Please select a platform.
        </Form.Control.Feedback>
      </Form.Group>

      <Button type="submit" className="mt-3">
        Register Host
      </Button>
    </Form>
  );
};

export default AdminRegisterHost;
